<template>
  <!--顶部部分（咨询联系/返回顶部）-->
  <div class="fixR">
    <div class="contact" v-popover:popover><i class="icon_contact"></i>咨询联系</div>
    <a class="toTop" title="返回顶部" @click="toTop"></a>
    <el-popover ref="popover" placement="left-start" width="250" trigger="hover">
      <div class="dialog flexCol_aroud">
        <div class="line flex_align">
          <i class="icon_phone"></i>
          <div class="flexCol_center">
            <p>咨询热线</p>
            <p class="blue">0571-8861-6565</p>
          </div>
        </div>
        <div class="line flex_align">
          <i class="icon_qq"></i>
          <div class="flexCol_center">
            <p>QQ客户服务</p>
            <p class="blue"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes"
                                target="_blank">点击咨询</a></p>
          </div>
        </div>
        <div class="line flex_align">
          <i class="icon_email"></i>
          <div class="flexCol_center">
            <p>电子邮件</p>
            <p class="email_p">support@Newdun.com</p>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
  export default {
    name: "returnTop",
    methods:{
      toTop(){//返回顶部
        scrollTo({
          top:0,
          behavior:'smooth'
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  /*返回顶部*/
  .fixR {
    position: fixed;
    bottom: 160px;
    right: 20px;
    z-index: 100;
    width: 44px;
  .contact {
    background: #2F87FF;
    border-radius: 1px;
    width: 44px;
    height: 128px;
    line-height: 22px;
    padding: 8px 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #FFFFFF;
  .icon_contact {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url("../assets/product.svg") -2384px -190px;
  }
  &:hover {
     cursor: pointer;
     opacity: 0.95;
   }
  }
  .toTop {
    display: inline-block;
    margin-top: 30px;
    width: 44px;
    height: 44px;
    line-height: 44px;
    border-radius: 2px;
    background: url("../assets/product.svg") -2369px -207px #2F87FF;
  &:hover {
     cursor: pointer;
     opacity: 0.95;
   }
  }
  }
  .dialog {
    /*position: fixed;
    bottom: 255px;
    right: 76px;*/
    width: 100%;
    height: 180px;
    text-align: left;
    .line {
      position: relative;
      span.i_close {
        display: inline-block;
        position: absolute;
        right: -10px;
        top: -14px;
        color: #bbb;
        width: 30px;
        height: 30px;
        text-align: center;
        &:hover {
          cursor: pointer;
        }
      }
      > i {
        display: inline-block;
        width: 40px;
        height: 41px;
        margin-right: 5px;
      }
      .icon_phone {
        background: url("../assets/product.svg") -2296px -186px;
      }
      .icon_qq {
        background: url("../assets/product.svg") -2296px -241px;
      }
      .icon_email {
        background: url("../assets/product.svg") -2296px -296px;
      }
      p{
        font-size: 12px;
        color: #000;
        font-family: 'pingfang';
      }
      .blue {
        font-size: 18px;
        color: #2F87FF;
        font-family: 'pingfangBold';
        a{
          display: inline-block;
          width: 100%;
          font-size: 12px;
          color: #2F87FF;
          font-family: 'pingfangBold';
          text-decoration: none;
          &:hover {
            cursor: pointer;
          }
        }
      }
      .email_p{
        font-size: 14px;
        color: #9B9B9B;
        font-family: 'pingfang';
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/returnTop.vue